import _asyncToGenerator from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import IconMetaMask from "../assets/images/metamask.svg";
import IconSafe from "../assets/images/safe.svg";
import IconWalletConnect from "../assets/images/WalletConnect.svg";
import IconCoinBase from "../assets/images/coinbase.svg";
import IconImToken from "../assets/images/imtoken.svg";
import IconImKey from "../assets/images/imKey-icon.svg";
import { initializeConnector } from '@web3-react/core';
import { Network } from '@web3-react/network';
import { MetaMask } from '@web3-react/metamask';
import { GnosisSafe } from '@web3-react/gnosis-safe';
import { CoinbaseWallet } from '@web3-react/coinbase-wallet';
import { EIP1193 } from '@web3-react/eip1193';
import { ALL_SUPPORTED_RPC_URLS, DEFAULT_RPC_PROVIDERS } from "../constants/chain";
import { host } from "../utils/host";
import { ConnectionType } from "./type";
import { isMetaMaskWallet } from "./detect";
import ImTokenQRCodeModal from "../components/WalletModal/Components/showImTokenQRCodeModal";
import { updateSelectedConnectionType } from "../state/user/actions";
import { Goerli, Mainnet } from "../model/chain/ethereum";
import { ENV } from "../constants/env";
import { WalletConnectV2 } from "./WalletConnectV2";
import { URI_AVAILABLE } from '@web3-react/walletconnect-v2';
import { ImKeyConnect } from "./ImKey";
import TokenWebView from '@consenlabs-fe/webview';
var rpcMap = ALL_SUPPORTED_RPC_URLS;
var defaultChainId = ENV.development || ENV.local ? Goerli.chainId : Mainnet.chainId;

function onError(error) {
  console.debug('initializeConnector error:', error);
}

var _initializeConnector = initializeConnector(function (actions) {
  return new Network({
    actions: actions,
    // urlMap: DEFAULT_RPC_PROVIDERS as any,
    urlMap: DEFAULT_RPC_PROVIDERS,
    defaultChainId: 1
  });
}),
    _initializeConnector2 = _slicedToArray(_initializeConnector, 2),
    web3Network = _initializeConnector2[0],
    web3NetworkHooks = _initializeConnector2[1];

export var networkConnection = {
  name: 'Network',
  connector: web3Network,
  hooks: web3NetworkHooks,
  type: ConnectionType.Network,
  shouldDisplay: function shouldDisplay() {
    return false;
  }
}; // Injected Browser Wallet

var _initializeConnector3 = initializeConnector(function (actions) {
  return new MetaMask({
    actions: actions,
    onError: onError
  });
}),
    _initializeConnector4 = _slicedToArray(_initializeConnector3, 2),
    web3Injected = _initializeConnector4[0],
    web3InjectedHooks = _initializeConnector4[1];

export var injectedConnection = {
  get name() {
    if (TokenWebView.isTokenEnv()) return 'imToken';
    return isMetaMaskWallet() ? 'MetaMask' : 'Browser Wallet';
  },

  icon: TokenWebView.isTokenEnv() ? IconImToken : IconMetaMask,
  hooks: web3InjectedHooks,
  connector: web3Injected,
  type: ConnectionType.Injected,
  shouldDisplay: function shouldDisplay(_bp, client) {
    return client.isDesktop || client.isImTokenApp ? true : false;
  }
}; // Gnosis Safe Wallet

var _initializeConnector5 = initializeConnector(function (actions) {
  return new GnosisSafe({
    actions: actions
  });
}),
    _initializeConnector6 = _slicedToArray(_initializeConnector5, 2),
    web3GnosisSafe = _initializeConnector6[0],
    web3GnosisSafeHooks = _initializeConnector6[1];

export var gnosisSafeConnection = {
  name: 'Safe',
  icon: IconSafe,
  connector: web3GnosisSafe,
  hooks: web3GnosisSafeHooks,
  type: ConnectionType.GnosisSafe,
  shouldDisplay: function shouldDisplay() {
    if (typeof window === 'undefined') return false;
    if (window !== window.parent) return true;
    return false;
  }
};

var _initializeConnector7 = initializeConnector(function (actions) {
  return new WalletConnectV2({
    actions: actions,
    defaultChainId: defaultChainId,
    onError: onError
  });
}),
    _initializeConnector8 = _slicedToArray(_initializeConnector7, 2),
    web3WalletConnectV2 = _initializeConnector8[0],
    web3WalletConnectV2Hooks = _initializeConnector8[1];

export var walletConnectV2Connection = {
  name: 'WalletConnect',
  icon: IconWalletConnect,
  connector: web3WalletConnectV2,
  hooks: web3WalletConnectV2Hooks,
  type: ConnectionType.WalletConnectV2,
  shouldDisplay: function shouldDisplay(bp, client) {
    if (client.isImTokenApp) return false;
    return client.isDesktop || bp.isMobile ? true : false;
  },
  activate: function () {
    var _activate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(connector, dispatch, chainId) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // A quick fix for dynamically configure requiredNamespaces based on user-selected chainId
              // https://github.com/Uniswap/web3-react/issues/867#issuecomment-1657126317
              // @ts-ignore
              connector.chains = [chainId];
              _context.next = 3;
              return connector.activate(chainId);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function activate(_x, _x2, _x3) {
      return _activate.apply(this, arguments);
    }

    return activate;
  }()
}; // imToken WalletConnect V2 with qrcode

var _initializeConnector9 = initializeConnector(function (actions) {
  return new WalletConnectV2({
    actions: actions,
    defaultChainId: defaultChainId,
    onError: onError,
    qrcode: false
  });
}),
    _initializeConnector10 = _slicedToArray(_initializeConnector9, 2),
    imTokenWalletConnect = _initializeConnector10[0],
    imTokenWalletConnectHooks = _initializeConnector10[1];

export var imTokenWalletConnectConnection = {
  name: 'imToken',
  icon: IconImToken,
  shouldDisplay: function shouldDisplay(_bp, client) {
    return client.isDesktop;
  },
  connector: imTokenWalletConnect,
  hooks: imTokenWalletConnectHooks,
  type: ConnectionType.ImTokenWalletConnect,
  activate: function () {
    var _activate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(connector, dispatch, chainId) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // A quick fix for dynamically configure requiredNamespaces based on user-selected chainId
              // https://github.com/Uniswap/web3-react/issues/867#issuecomment-1657126317
              // @ts-ignore
              connector.chains = [chainId];
              connector.events.on(URI_AVAILABLE, function (uri) {
                var _connector$provider, _connector$provider2;

                ImTokenQRCodeModal.open(uri);
                (_connector$provider = connector.provider) === null || _connector$provider === void 0 ? void 0 : _connector$provider.on('disconnect', function () {
                  dispatch(updateSelectedConnectionType(null));
                });
                (_connector$provider2 = connector.provider) === null || _connector$provider2 === void 0 ? void 0 : _connector$provider2.on('connect', function () {
                  ImTokenQRCodeModal.close();
                });
              });
              _context2.next = 4;
              return connector.activate(chainId);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function activate(_x4, _x5, _x6) {
      return _activate2.apply(this, arguments);
    }

    return activate;
  }()
}; // imToken WalletConnect V2 with call app

var _initializeConnector11 = initializeConnector(function (actions) {
  return new WalletConnectV2({
    actions: actions,
    defaultChainId: defaultChainId,
    onError: onError,
    qrcode: false
  });
}),
    _initializeConnector12 = _slicedToArray(_initializeConnector11, 2),
    imTokenCallApp = _initializeConnector12[0],
    imTokenCallAppHooks = _initializeConnector12[1];

export var imTokenCallAppConnection = {
  name: 'imToken',
  icon: IconImToken,
  connector: imTokenCallApp,
  hooks: imTokenCallAppHooks,
  type: ConnectionType.ImTokenCallApp,
  shouldDisplay: function shouldDisplay(bp, client) {
    return bp.isMobile && !client.isImTokenApp ? true : false;
  },
  activate: function () {
    var _activate3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(connector, dispatch, chainId) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // A quick fix for dynamically configure requiredNamespaces based on user-selected chainId
              // https://github.com/Uniswap/web3-react/issues/867#issuecomment-1657126317
              // @ts-ignore
              connector.chains = [chainId];
              connector.events.on(URI_AVAILABLE, function (uri) {
                var _connector$provider3, _connector$provider4;

                console.log('open imToken wc2 uri', uri);
                window.open("imtokenv2://wc?uri=".concat(encodeURIComponent(uri)), '_blank');
                (_connector$provider3 = connector.provider) === null || _connector$provider3 === void 0 ? void 0 : _connector$provider3.on('disconnect', function () {
                  dispatch(updateSelectedConnectionType(null));
                });
                (_connector$provider4 = connector.provider) === null || _connector$provider4 === void 0 ? void 0 : _connector$provider4.on('connect', function () {
                  ImTokenQRCodeModal.close();
                });
              });
              _context3.next = 4;
              return connector.activate(chainId);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function activate(_x7, _x8, _x9) {
      return _activate3.apply(this, arguments);
    }

    return activate;
  }()
}; // Coinbase Wallet

var _initializeConnector13 = initializeConnector(function (actions) {
  return new CoinbaseWallet({
    actions: actions,
    options: {
      url: rpcMap[1],
      appName: 'Tokenlon',
      appLogoUrl: "".concat(host.href, "images/favicon.png")
    },
    onError: onError
  });
}),
    _initializeConnector14 = _slicedToArray(_initializeConnector13, 2),
    web3CoinbaseWallet = _initializeConnector14[0],
    web3CoinbaseWalletHooks = _initializeConnector14[1];

export var coinbaseWalletConnection = {
  name: 'Coinbase Wallet',
  icon: IconCoinBase,
  connector: web3CoinbaseWallet,
  hooks: web3CoinbaseWalletHooks,
  type: ConnectionType.Coinbase,
  shouldDisplay: function shouldDisplay(bp, client) {
    if (client.isImTokenApp) return false;
    return client.isDesktop || bp.isMobile ? true : false;
  }
}; // imKey

var imKeyProvider = new ImKeyConnect({
  headers: {
    agent: 'ios:2.9.11.1539:6',
    deviceToken: 'test1234'
  },
  language: typeof window === 'undefined' ? 'en' : navigator.languages[0],
  chainId: ENV.production ? Mainnet.chainId : Goerli.chainId,
  rpcUrl: Mainnet.rpcUrl
});

var _initializeConnector15 = initializeConnector(function (actions) {
  return new EIP1193({
    actions: actions,
    provider: imKeyProvider
  });
}),
    _initializeConnector16 = _slicedToArray(_initializeConnector15, 2),
    imKey = _initializeConnector16[0],
    imKeyHooks = _initializeConnector16[1];

export var imKeyConnection = {
  name: 'imKey',
  icon: IconImKey,
  connector: imKey,
  hooks: imKeyHooks,
  type: ConnectionType.ImKey,
  shouldDisplay: function shouldDisplay(_bp, client) {
    return client.isDesktop ? true : false;
  }
};
export var SELECTABLE_CONNECTIONS = [imTokenWalletConnectConnection, imTokenCallAppConnection, injectedConnection, gnosisSafeConnection, walletConnectV2Connection, coinbaseWalletConnection, imKeyConnection];
export var CONNECTIONS = [networkConnection].concat(SELECTABLE_CONNECTIONS);